/**
 * The Meet With mark: two overlapping tiles with a window where they meet.
 *
 * Geometry is from the brand handoff, in units of the tile size S: tiles are
 * S wide with radius 0.32S, the right tile offset by 0.5S, and the window
 * 0.5S wide with radius 0.176S. Drawn rather than imported so it inherits the
 * current theme — on dark grounds the window is Paper, not Ink.
 */
export function Mark({ size = 24, onDark = false }: { size?: number; onDark?: boolean }) {
  return (
    <svg
      viewBox="0 0 150 100"
      width={(size * 3) / 2}
      height={size}
      role="img"
      aria-label="Meet With"
      focusable="false"
    >
      <rect x="0" y="0" width="100" height="100" rx="32" fill="var(--mw-tide)" />
      <rect x="50" y="0" width="100" height="100" rx="32" fill="var(--mw-coral)" />
      <rect
        x="50"
        y="0"
        width="50"
        height="100"
        rx="17.6"
        fill={onDark ? "var(--mw-paper)" : "var(--mw-ink)"}
      />
    </svg>
  );
}

/**
 * Symbol plus wordmark. "Meet" in Ink, "With" in Tide — and on dark grounds,
 * Paper and Tide-light. Never stacked on two lines.
 */
export function Lockup({ size = 22 }: { size?: number }) {
  return (
    <span className="lockup" style={{ gap: `${String(Math.round(size * 0.45))}px` }}>
      <Mark size={size} />
      <span
        className="wordmark"
        style={{ fontSize: `${String(Math.round(size * 1.3))}px` }}
      >
        Meet<span className="wordmark-with">With</span>
      </span>
    </span>
  );
}
